import React from "react";
import { Form } from "antd";
import { CustomDatePicker } from "../../../customComponent/CustomDatePicker";

export default function FormItemDatePicker({ disabled = false, onChange = null, datePicketStyle = {}, ...props }) {
  return (
    <Form.Item style={{ margin: 0, width: "136px" }} {...props}>
      <CustomDatePicker disabled={disabled} onChange={onChange} style={datePicketStyle} />
    </Form.Item>
  );
}
